var pym = require("./lib/pym");
var ANALYTICS = require("./lib/analytics");
require("./lib/webfonts");
var { isMobile } = require("./lib/breakpoints");
var { classify, COLORS } = require ("./lib/helpers")

//Global vars
var skipLabels = ["label", "total", "values"];


var d3 = {
  ...require("d3-array/dist/d3-array.min"),
  ...require("d3-scale/dist/d3-scale.min"),
  ...require("d3-selection/dist/d3-selection.min"),
  ...require("d3-collection/dist/d3-collection.min")
};

var pymChild = null;
pym.then(function(child) {
  pymChild = child;
  child.sendHeight();
  window.addEventListener("resize", render);

});

var render = function() {

  var container = document.querySelector(".graphic");
  window.DATA.forEach(e => renderWaffle({
    container: `#${classify(e.label)}`,
    data: e
  }));

function renderWaffle(config) {
  let data = config.data;
  let container = config.container;

  var colorScale = d3.scaleOrdinal()
    .domain(data.labels)
    .range([COLORS.wbezred, COLORS.gray2]);
  
    // Select your div
    const waffle = d3.select(container);

    // For each item in the array, add a div element
    waffle
      .selectAll('.block')
      .data(data.values)
      .enter()
      .append('div')
      .attr('class', d => `block block-${classify(d.label)}`)
      .style('background-color', function(d){
        return colorScale(d.label)
      })


  pym.then(function(child) {
    pymChild.sendHeight();
  });
  
};


}

var formatData = function(data) {
  
  data.forEach(function(d) {
    d.values = [];
    let labels = new Set();
    for (var label in d) {
      if (skipLabels.indexOf(label) <= -1) {
        labels.add(label);
        let arr = d3.range(d[label]);

        arr.forEach(function(e) {
          d.values.push({
            label: label
          }); 
        });
      } else {
        //skip label and do nothing  
      }
    }
    d.labels = Array.from(labels);
  })

  }

//first render
formatData(window.DATA);
render();